
(function(template){
    define('vue!basicComponents/modal',['Vue'],function(Vue){
        return {
            name:'Modal',
            template:template,
            props: ['className', 'modalId', 'triggerButtonText', 'closeButtonText', 'confirmButtonText', 'disabled'],
            methods: {
                handleClose: function() {
                    this.$emit('close');
                },
                handleConfirm: function() {
                    this.$emit('confirm');
                }
            }
        }
    })
})('<div class="modalContainer"> <div :id="modalId" class="modal hide fade vueModal" tabindex="-1" data-backdrop="static" role="dialog" :aria-labelledby="modalId.concat(\'Label\')" aria-hidden="true"> <div class="modal-header"> <button type="button" class="close" data-dismiss="modal" @click="handleClose" aria-hidden="true">×</button> <slot name="modalHeader"></slot> </div> <div class="modal-body"> <slot name="modalBody"></slot> </div> <div class="modal-footer"> <button class="btn" data-dismiss="modal" @click="handleClose" aria-hidden="true" v-if="!!closeButtonText" >{{closeButtonText}}</button> <button class="btn btn-primary" data-dismiss="modal" @click="handleConfirm" v-if="!!confirmButtonText" >{{confirmButtonText}}</button> </div> </div> <button :disabled="disabled" :class="className" data-toggle="modal" :data-target="\'#\'+modalId" >{{triggerButtonText}}</button> </div>');
